module.exports = __webpack_public_path__ + "./img/notification_bell_on.svg";